module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group col-md-12 required",
    class: {
      'has-error': _vm.errors.first(_vm.nomeCampo)
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.nomeCampo))]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorPhone",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telefone),
      expression: "telefone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (['(##) ####-####', '(##) #####-####']),
      expression: "['(##) ####-####', '(##) #####-####']"
    }],
    staticClass: "form-control",
    attrs: {
      "name": _vm.nomeCampo,
      "type": "tel"
    },
    domProps: {
      "value": (_vm.telefone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telefone = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.first(_vm.nomeCampo)) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first(_vm.nomeCampo)))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09a8e17f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/telefone.vue
// module id = 1856
// module chunks = 1